import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

// Drafts describe suggested actions in the past tense ("I've approved the
// increase") because staff are expected to run the action first. Before a
// send, catch a thread whose executable action hasn't been run.

const NOTHING_TO_DO_STATES = new Set(['active', 'already_done']);

export function actionLabel(staffAction) {
  return staffAction?.title || staffAction?.label || staffAction?.preflight?.verb || 'the suggested action';
}

/** First executable staff action on the thread that still needs running, or null. */
export function findUnrunStaffAction(thread) {
  const actions = Array.isArray(thread?.staff_actions) ? thread.staff_actions : [];
  return (
    actions.find((entry) => {
      if (!entry || entry.executed) return false;
      const preflight = entry.preflight || {};
      if (preflight.blocked) return false;
      return !NOTHING_TO_DO_STATES.has(preflight.state);
    }) || null
  );
}

export default function UnrunActionDialog({ staffAction, running, onRun, onSendAnyway, onClose }) {
  return (
    <Dialog open={Boolean(staffAction)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Action not run yet</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          This reply says &apos;{actionLabel(staffAction)}&apos; is done, but it hasn&apos;t been run yet. Run it
          first, or send anyway?
        </Typography>
        {staffAction?.preflight?.message ? (
          <Typography variant="caption" color="text.secondary" component="div" mt={1}>
            {staffAction.preflight.message}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSendAnyway}>Send anyway</Button>
        <Button variant="contained" disableElevation disabled={running} onClick={() => onRun(staffAction)}>
          {running ? 'Running…' : 'Run it'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UnrunActionDialog.propTypes = {
  staffAction: PropTypes.object,
  running: PropTypes.bool,
  onRun: PropTypes.func.isRequired,
  onSendAnyway: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
UnrunActionDialog.defaultProps = { staffAction: null, running: false };
